import { render, staticRenderFns } from "./urbanizadora.vue?vue&type=template&id=601648a0"
import script from "./urbanizadora.vue?vue&type=script&lang=js"
export * from "./urbanizadora.vue?vue&type=script&lang=js"
import style0 from "./urbanizadora.vue?vue&type=style&index=0&id=601648a0&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports